import React from 'react';
import { formatPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Icon from '../../../components/Icon';
import { PhoneWrapper, PhoneLinkWrapper } from './styleInfosModal';
import { useTranslation } from 'next-i18next';

const ContactInfoModal = ({ ...props }) => {
  const { t } = useTranslation();

  const {
    data: { contactNumber },
  } = props;

  let prettyPhoneNumber = contactNumber;

  const pn = parsePhoneNumber(contactNumber);
  if (pn) {
    prettyPhoneNumber = formatPhoneNumber(contactNumber);
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        flexBox
        style={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <PhoneWrapper>
          <Icon name="ios-call" fontSize={32} color="#fff" mr={10} />
        </PhoneWrapper>

        <PhoneLinkWrapper href={'tel:' + contactNumber}>
          {prettyPhoneNumber}
        </PhoneLinkWrapper>
      </Box>

      <Box
        flexBox
        style={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          backgroundColor: '#F8F8F8',
          marginTop: 20,
          paddingTop: 20,
          paddingBottom: 20,
          paddingLeft: 30,
          paddingRight: 30,
        }}
      >
        <Text
          content={t('report.report')}
          as="span"
          fontSize={16}
          fontWeight={700}
          color="#333333"
          mb={10}
        />

        <Text
          content={t('report.contact')}
          as="span"
          fontSize={14}
          fontWeight={400}
          color="#595959"
          mb={3}
        />
        <a
          style={{ textAlign: 'center' }}
          href={`mailto:${process.env.MAIL_FROM_EMAIL}`}
        >
          {process.env.MAIL_FROM_EMAIL}
        </a>
      </Box>
    </div>
  );
};

export default ContactInfoModal;
